import React from 'react'
import ImageTextSection from '../components/imageTextSection'
import HomeImagesSection from '../components/homeImagesSection'

const Home = () => {
    return (
        <div className="">
            <HomeImagesSection />
            <ImageTextSection />
           
        </div>
    )
}

export default Home